import {inject, Injectable} from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateFn} from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { TabStateService } from '@shared//services/tab-state.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
class PermissionsService {


    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private tabService = inject(TabStateService);
    private translateService = inject(TranslateService);



  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        // Navigate to the deepest child route
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      switchMap(route => route.data)
    )
    .subscribe(data => {
      this.handleNavigation(data);
    });
    return true;

  }

  private handleNavigation(routeData: any): void {
    // Solo procesar si la ruta tiene openTab: true
    if (routeData?.openTab === true) {
      const currentUrl = this.router.url;

      // Obtener información del tab
      const title = routeData.breadcrumb || routeData.title || 'Sin título';
      const icon = routeData.icon || 'pi pi-file';


      // Abrir tab usando el servicio
      this.tabService.openTab({
        route: currentUrl,
        title: this.translateService.instant(title),
        icon: icon,
        closable: true
      });
    }
  }


}

export const TabsGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}
